import React from "react";

import ChoosePayment from "../components/auth/ChoosePayment";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";

const Login = () => {
  return (
    <div>
      <Header />
      <ChoosePayment />
      <Footer />
    </div>
  );
};

export default Login;
